import Vue from 'vue'
import FunctionNode from './nodes/FunctionNode'
import SwitchNode from './nodes/SwitchNode'
import StartNode from './nodes/StartNode'
import FetchNode from './nodes/FetchNode'
import DelayNode from './nodes/DelayNode'
import FlowLink from './FlowLink'
import Palette from './tools/Palette.vue'
import VueHtmlNode from './nodes/VueHtmlNode'
import LowBeamNode from './nodes/LowBeamNode'
import HighBeamNode from './nodes/HighBeamNode'
import BrakeLightNode from './nodes/BrakeLightNode'
import HazardWarningLampNode from './nodes/HazardWarningLampNode'
import CorneringLampNode from './nodes/CorneringLampNode'
import PositionLampNode from './nodes/PositionLampNode'
import ParkingLampNode from './nodes/ParkingLampNode'
import HeadlightHeightNode from './nodes/HeadlightHeightNode'
import RearviewMirrorNode from './nodes/RearviewMirrorNode'
import RearviewMirrorDefrostingNode from './nodes/RearviewMirrorDefrostingNode'
import HornNode from './nodes/HornNode'
import DoorNode from './nodes/DoorNode'
import DoorWindowNode from './nodes/DoorWindowNode'
import WiperNode from './nodes/WiperNode'
import KeyNode from './nodes/KeyNode'
import LockDoorNode from './nodes/LockDoorNode'
import RearDoorNode from './nodes/RearDoorNode'
import BackLightNode from './nodes/BackLightNode'
import DayLightNode from './nodes/DayLightNode'
import AfterFogLampsNode from './nodes/AfterFogLampsNode'
import WindowMistForwardNode from './nodes/WindowMistForwardNode'
import WindowMistBackNode from './nodes/WindowMistBackNode'
import HumidityNode from './nodes/HumidityNode'
import TemperatureNode from './nodes/TemperatureNode'
import RainNode from './nodes/RainNode'

class NodeRedExtension {
  static pluginName = 'NodeRedExtension'
  constructor({ lf }) {
    lf.register(FunctionNode)
    lf.register(SwitchNode)
    lf.register(StartNode)
    lf.register(FetchNode)
    lf.register(LowBeamNode)
    lf.register(HighBeamNode)
    lf.register(BrakeLightNode)
    lf.register(HazardWarningLampNode)
    lf.register(CorneringLampNode)
    lf.register(PositionLampNode)
    lf.register(ParkingLampNode)
    lf.register(HeadlightHeightNode)
    lf.register(RearviewMirrorNode)
    lf.register(RearviewMirrorDefrostingNode)
    lf.register(HornNode)
    lf.register(DoorNode)
    lf.register(DoorWindowNode)
    lf.register(WiperNode)
    lf.register(KeyNode)
    lf.register(LockDoorNode)
    lf.register(RearDoorNode)
    lf.register(BackLightNode)
    lf.register(DayLightNode)
    lf.register(AfterFogLampsNode)
    lf.register(WindowMistForwardNode)
    lf.register(WindowMistBackNode)
    lf.register(HumidityNode)
    lf.register(TemperatureNode)
    lf.register(RainNode)
    lf.register(FlowLink)
    lf.register(DelayNode)
    lf.register(VueHtmlNode)
    lf.setDefaultEdgeType('flow-link')
    this.app = new Vue({
      render: h => {
        return h(Palette, {
          props: {
            lf
          }
        })
      }
    })
  }
  render(lf, domOverlay) {
    const node = document.createElement('div')
    node.className = 'node-red-palette'
    domOverlay.appendChild(node)
    this.app.$mount(node)
  }
}

export default NodeRedExtension
